import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  plan:{},
  registrationToken:'',
  discountCode:''
}

const subscriptionsSlice = createSlice({
  name: 'subscriptions',
  initialState: initialState,
  reducers: {
    setPlan(state, action) {
      state.plan = action.payload
    },
    setRegistrationToken(state, action) {
      state.registrationToken = action.payload
    },
    setDiscountCode(state, action) {
      state.discountCode = action.payload
    },
    resetAll(state) {
      Object.assign(state, initialState)
    }
  }
})

export const subscriptionsActions = subscriptionsSlice.actions

export const subscriptionsReducer = subscriptionsSlice.reducer
